import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {currentResource} from '../../../util/utils';
import {
	clearRisk,
	createAssertionRiskRelation,
	createNewRisk,
	getRiskById,
	updateRisk
} from '../../../actions/Risk/riskactions';
//import CreateEditEstimateModal from './CreateEditEstimateModal/src';
import {CreateEditEstimateModal} from '@ey/canvascoreservices';
import Utility from '../../../util/utilityfunctions';
import {clearErrors} from '../../../actions/erroractions';
import {updateStoreAccountRelation} from '../../../actions/Account/accountactions';
import ErrorSummary from '../ErrorSummary/ErrorSummary';
import {setIsModalOpen} from '../../../actions/setismodalopen';

export default function CreateEditEstimateModalWrapper(props) {
	const {isCreate, isEdit, showModal, setShowModal, onClose, estimateId, isManageEntities = true} = props;
	const [engagementId, risk, account] = useSelector((state) => [
		state.engagementId,
		state.risk?.createEditEstimate,
		state.account
	]);
	const userPreferences = useSelector((state) => state.userPreferences);
	const dispatch = useDispatch();

	useEffect(() => {
		if (showModal) {
			dispatch(setIsModalOpen(true));
		} else {
			dispatch(setIsModalOpen(false));
		}
	}, [showModal]);

	const estimateAssertionRelationShip = (res) => {
		let newEstimateRelations = [];
		if (account.assertions.length > 0) {
			account.assertions.map((assertion) => {
				newEstimateRelations.push({assertionId: assertion.id});
			});
		} else {
			const knowledgeAssertionId = Utility.getKnowledgeAssertionId(account?.statementTypeId);
			newEstimateRelations.push({accountId: account.id, knowledgeAssertionId: knowledgeAssertionId});
		}
		if (newEstimateRelations.length > 0) {
			dispatch(createAssertionRiskRelation(engagementId, res, newEstimateRelations, null, null, null, true)).then(
				(res) => {
					if (account.assertions.length === 0) {
						dispatch(updateStoreAccountRelation(res));
					}
				}
			);
		}
	};

	return (
		<>
			{isCreate && (
				<CreateEditEstimateModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					createEstimateAction={(data) =>
						dispatch(createNewRisk(engagementId, data, {isManageEstimates: isManageEntities})).then(
							(res) => account.id && res.id && estimateAssertionRelationShip(res)
						)
					}
					labels={currentResource.CreateEditEstimateLabels}
					onClose={onClose}
					userPreferences={userPreferences}
					theme={Utility.getTheme()}
					errorComponent={<ErrorSummary />}
				/>
			)}
			{isEdit && (
				<CreateEditEstimateModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditEstimateLabels}
					estimateDetails={risk}
					estimateId={estimateId}
					userPreferences={userPreferences}
					onClose={() => {
						dispatch(clearRisk({isManageEstimates: isManageEntities})).then(() => dispatch(clearErrors()));
						onClose && onClose();
					}}
					editEstimateAction={(data) => {
						if (account.id && data.id) estimateAssertionRelationShip(data);
						return dispatch(updateRisk(engagementId, data, {isManageEstimates: isManageEntities})).then(() => {
							props.onEditAccountAction && props.onEditAccountAction();
						});
					}}
					getEstimateById={() =>
						getRiskById(Number(engagementId), Number(estimateId), {}, {isManageEstimates: isManageEntities})
					}
					theme={Utility.getTheme()}
					errorComponent={<ErrorSummary />}
				/>
			)}
		</>
	);
}
